module.exports = __webpack_public_path__ + "static/media/1.eaa2779.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/english/home/pc/role/video/1.wav
// module id = d6Sp
// module chunks = 0